import React, { memo, useMemo } from 'react';
import { Select, Tooltip } from 'antd';
import { shallowEqual, useSelector } from 'react-redux';
import { dspxGetChildrens } from '../../../../../../helpers/dspx-utils';
import { ReactComponent as ParametersFilterIcon } from '../../../../../../resource/ParametrFilterIcon.svg';
import { ExpireIcon, UrgentIcon } from '../../../../../../resource/icons';
import groupSubservices from '../../../lib/groupSubservices';
import {
  hasFilterValue,
  selectServiceActiveCount,
} from '../../../model/activity';
import { useRequestFilterCommands } from '../../../model/commandsContext';
import { requestFilterSectionIds } from '../../../model/sectionExpansion';
import { useFilterChange } from '../../../model/useFilterChange';
import FilterField from '../../primitives/FilterField';
import FlagControl from '../../primitives/FlagControl';
import FilterSection from '../../primitives/FilterSection';
import { multiSelectTagProps } from '../../primitives/selectTagProps';
import styles from './ServiceFilterSection.module.scss';

const { Option } = Select;

const selectServiceFilterState = (state) => {
  const filter = state.filterStore;

  return {
    listService: filter.listService,
    listSubservice: filter.listSubservice,
    valueService: filter.valueService,
    valueSubservice: filter.valueSubservice,
    immediate: filter.immediate,
    expiredOnly: filter.expiredOnly,
  };
};

const ServiceFilterSection = () => {
  const filterCommands = useRequestFilterCommands();
  const filter = useSelector(selectServiceFilterState, shallowEqual);
  const activeCount = useSelector(selectServiceActiveCount);
  const { changeFilter } = useFilterChange();

  const subserviceGroups = useMemo(
    () => groupSubservices(filter.listSubservice),
    [filter.listSubservice]
  );

  return (
    <FilterSection
      sectionId={requestFilterSectionIds.service}
      heading="Категории"
      description="Тип работ и причина обращения"
      icon={<ParametersFilterIcon />}
      activeCount={activeCount}
    >
      <div className={styles.grid}>
        <FilterField
          label="Услуга"
          active={hasFilterValue(filter.valueService)}
        >
          <Select
            {...multiSelectTagProps}
            mode="multiple"
            defaultActiveFirstOption={false}
            allowClear={true}
            placeholder="Выберите услугу"
            notFoundContent="нет данных"
            value={filter.valueService}
            onChange={(value) => {
              changeFilter(filterCommands.applyService(value));
            }}
            optionFilterProp="searchtext"
          >
            {dspxGetChildrens(filter.listService)}
          </Select>
        </FilterField>

        <FilterField
          label="Причина"
          active={hasFilterValue(filter.valueSubservice)}
        >
          <Select
            {...multiSelectTagProps}
            mode="multiple"
            defaultActiveFirstOption={false}
            allowClear={true}
            placeholder="Выберите причину"
            notFoundContent="нет данных"
            value={filter.valueSubservice}
            onChange={(value) => {
              changeFilter(filterCommands.applySubservice(value));
            }}
            optionFilterProp="searchtext"
          >
            {subserviceGroups.map((group) => (
              <Select.OptGroup
                key={group.id}
                label={group.name}
              >
                {group.options.map((option) => (
                  <Option
                    key={option.id}
                    searchtext={option.name}
                  >
                    {option.name.length > 30 ? (
                      <Tooltip title={option.name}>{option.name}</Tooltip>
                    ) : (
                      option.name
                    )}
                  </Option>
                ))}
              </Select.OptGroup>
            ))}
          </Select>
        </FilterField>

        <FlagControl
          active={filter.immediate}
          icon={<UrgentIcon />}
          onChange={(value) => {
            changeFilter(filterCommands.applyImmediate(value));
          }}
        >
          Аварийная
        </FlagControl>

        <FlagControl
          active={filter.expiredOnly}
          icon={<ExpireIcon />}
          onChange={(value) => {
            changeFilter(filterCommands.applyExpiredOnly(value));
          }}
        >
          Просроченная
        </FlagControl>
      </div>
    </FilterSection>
  );
};

export default memo(ServiceFilterSection);
